module.exports = __webpack_public_path__ + "static/media/placeholder.83f3f36d.jpg";